<template>
  <modal :title="addShow?'Add ElektraWeb Role':'ElektraWeb Roles'" @close="$emit('close')">
    <template #content>
      <load-area v-if="data == null"></load-area>
      <div v-show="!addShow">
        <div
          v-if="data != null"
          class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
        >
          <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
            <button
              class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
              type="button"
              @click="addShow = true"
              :key="index"
            >
              <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
              <span class="p-l-20 p-r-10">Add Function</span>
            </button>
          </div>
        </div>
        <dataTable
          :name="'ElektraWebRoles'"
          :columnDefs="columnDefs"
          ref="agGrid"
          :data="data"
          v-if="data != null"
          @update="updateShow = { ...$event }"
          @remove="remove"
        ></dataTable>
      </div>
      <add v-if="data!=null && addShow" :roles="roles" :functions="functions" @add="get()" @close="get();addShow=false"></add>
    </template>
  </modal>
</template>

<script>
import add from "./add.vue";
export default {
  name: "ElektrawebRoles",
  components: { add },
  data() {
    return {
    roles: null,
      functions: null,
      data: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 40,
        },
        {
          headerName: "RoleName",
          field: "RoleName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Function",
          field: "functionName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
        },
      ],
      addShow: false,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`ElektrawebRoles`).then((rsp) => {
        this.roles = rsp.data;
        this.$appAxiosAdmin.get(`ElektrawebFunctions`).then((response) => {
        this.functions = response.data;
        this.get();
        });
    });
  },
  methods: {
    get() {
      this.$appAxiosAdmin.get(`ElektrawebRoleFunctions`).then((response) => {
        this.data = response.data.map((r) => {
          r.functionName =
            this.functions.find((f) => f.Id === r.FunctionId)?.FunctionName ||
            "Unknown";
          return r;
        });
      });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the role?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`ElektrawebRoleFunctions/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The role has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
